import { render, staticRenderFns } from "./iconMessage.vue?vue&type=template&id=060a22cf&scoped=true"
import script from "./iconMessage.vue?vue&type=script&lang=js"
export * from "./iconMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a22cf",
  null
  
)

export default component.exports